import { render } from "./clients-list-model.vue?vue&type=template&id=61180094"
import script from "./clients-list-model.vue?vue&type=script&lang=js"
export * from "./clients-list-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__